import { SxProps, Theme } from "@mui/material";

export const filterWrapperSx = (_theme: Theme): SxProps<Theme> => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2,
});
